import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'pdf-modal',
  templateUrl: './pdf-modal.component.html',
  styleUrls: ['./pdf-modal.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [PdfViewerModule],
})
export class PdfModalComponent implements OnInit {
  @Input() url: string = '';
  @ViewChild(PdfViewerComponent, { static: false })
  private pdfComponent: PdfViewerComponent;

  safeUrl: SafeResourceUrl;
  public hidePdf: boolean = true;
  constructor(
    public modal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.url}`);
  }

  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-width';
    this.pdfComponent.zoomScale = 'page-fit';
  }

  closePopup(): void {
    this.modal.close();
  }
}
